import { render } from "./IconProjectOneColorwheel.vue?vue&type=template&id=44b47f53"
import script from "./IconProjectOneColorwheel.vue?vue&type=script&lang=js"
export * from "./IconProjectOneColorwheel.vue?vue&type=script&lang=js"

import "./IconProjectOneColorwheel.vue?vue&type=style&index=0&id=44b47f53&lang=scss"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__